<div class="nbd-footer-bottom footer">
   <div class="col-md-12 p-0 text-center">
      <a href="https://www.smartfunder.co.za/privacy" target="_blank" rel="noopener noreferrer">
         <p> Privacy policy </p>
      </a>
   </div>
   <!-- Grid row -->
   <div class="row d-flex align-items-center">
      <!-- Grid column -->
      <div class="col-md-12 p-0 text-left">
         <!--Copyright-->
         <img src="assets/images/NEDBANK.svg" alt="nedbank">
      </div>
      <!-- Grid column -->
   </div>
   <!-- Grid row -->
   <div class="row nbd-footer-logo">
      <!-- Grid column -->
      <div class="text-left col-12 col-md-12 col-lg-9 p-0">
       
         <p class="text-left">Nedbank Ltd Reg No 1951/000009/06. Licensed financial services provider (FSP9363) and
            registered credit provider (NCRCP16)
         </p>

      </div>
      <!-- Grid column -->
      <div class="col-12 col-md-12 col-lg-3 ml-lg-0 p-0">
         <!-- Social buttons -->
         <div class="text-left text-md-left text-lg-right nbd-social-icons">
            <ul class="list-unstyled list-inline">








               <li class="list-inline-item">
                  <a href="https://www.facebook.com/Nedbank" rel="noopener noreferrer" target="_blank"
                     class="btn-floating rgba-white-slight" data-pagequicklinktype="link"
                     data-pagequicklinkname="nedbank-facebook" data-pagequicklinklocation="footer">
                     <img src="assets/images/facebook.svg" class="nbd-social-icon" alt="nedbank-facebook"
                        loading="lazy">
                  </a>
               </li>

               <li class="list-inline-item">
                  <a href="https://www.linkedin.com/company/nedbank" rel="noopener noreferrer" target="_blank"
                     class="btn-floating rgba-white-slight" data-pagequicklinktype="link"
                     data-pagequicklinkname="nedbank-linkedin" data-pagequicklinklocation="footer">
                     <img src="assets/images/linkedin.svg" class="nbd-social-icon" alt="nedbank-linkedin"
                        loading="lazy">
                  </a>
               </li>

               <li class="list-inline-item">
                  <a href="https://www.instagram.com/nedbank" rel="noopener noreferrer" target="_blank"
                     class="btn-floating rgba-white-slight" data-pagequicklinktype="link"
                     data-pagequicklinkname="nedbank-instagram" data-pagequicklinklocation="footer">
                     <img src="assets/images/instagram.svg" class="nbd-social-icon" alt="nedbank-instagram"
                        loading="lazy">
                  </a>
               </li>

               <li class="list-inline-item">
                  <a href="https://www.youtube.com/user/nedbank" rel="noopener noreferrer" target="_blank"
                     class="btn-floating rgba-white-slight" data-pagequicklinktype="link"
                     data-pagequicklinkname="nedbank-youtube" data-pagequicklinklocation="footer">
                     <img src="assets/images/youtube.svg" class="nbd-social-icon" alt="nedbank-youtube" loading="lazy">
                  </a>
               </li>

               <li class="list-inline-item">
                  <a href="https://twitter.com/Nedbank" rel="noopener noreferrer" target="_blank"
                     class="btn-floating rgba-white-slight" data-pagequicklinktype="link"
                     data-pagequicklinkname="nedbank-twitter" data-pagequicklinklocation="footer">
                     <img src="assets/images/twitter.svg" class="nbd-social-icon" alt="nedbank-twitter" loading="lazy">
                  </a>
               </li>




            </ul>
         </div>

      </div>
      <!-- Grid column -->
   </div>
</div>